export { ComponentClass } from 'react';
export { IEditor } from './components/IEditor';
export { ReactEditorProps } from './components/ReactEditor';
export { BareContentEditableDivEditorProps } from './components/BareContentEditableDivEditor';
export { EditorPluginEx, PluginUtils } from './utils/PluginUtils';
export { UndoService } from 'roosterjs-editor-core';

import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));

export let ReactEditor = createLazyComponent(lazyModule, m => m.ReactEditor);
export let BareContentEditableDivEditor = createLazyComponent(
    lazyModule,
    m => m.BareContentEditableDivEditor
);
export let lazyCreateUndo = new LazyImport(lazyModule, m => m.createUndo);
export let lazySetTableHeaderRow = new LazyImport(lazyModule, m => m.setTableHeaderRow);
